// actions.js
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  DELETE_NOTIFICATIONS_REQUEST,
  DELETE_NOTIFICATIONS_FAILURE,
  DELETE_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATION_REQUEST,
  FETCH_NOTIFICATION_SUCCESS,
  FETCH_NOTIFICATION_FAILURE,
  UPDATE_NOTIFICATIONS_REQUEST,
  UPDATE_NOTIFICATIONS_SUCCESS,
  UPDATE_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_RELEASE_REQUEST,
  FETCH_NOTIFICATIONS_RELEASE_SUCCESS,
  FETCH_NOTIFICATIONS_RELEASE_FAILURE,
  CLEAR_NOTIFICATION_ERRORS,
  CLEAR_NOTIFICATION_SUCCESS
} from './actionTypes';

export const fetchNotificationsRequest = () => ({
  type: FETCH_NOTIFICATIONS_REQUEST,
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const fetchNotificationsReleaseRequest = () => ({
  type: FETCH_NOTIFICATIONS_RELEASE_REQUEST,
});

export const fetchNotificationsReleaseSuccess = (notificationsRelease) => ({
  type: FETCH_NOTIFICATIONS_RELEASE_SUCCESS,
  payload: notificationsRelease,
});

export const fetchNotificationsReleaseFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_RELEASE_FAILURE,
  payload: error,
});

export const fetchNotificationRequest = (id) => ({
  type: FETCH_NOTIFICATION_REQUEST,
  payload: id
});

export const fetchNotificationSuccess = (notification) => ({
  type: FETCH_NOTIFICATION_SUCCESS,
  payload: notification,
});

export const fetchNotificationFailure = (error) => ({
  type: FETCH_NOTIFICATION_FAILURE,
  payload: error,
});

export const updateNotificationRequest = (notification, navigate) => ({
  type: UPDATE_NOTIFICATIONS_REQUEST,
  payload: { notification, navigate }
});

export const updateNotificationSuccess = () => ({
  type: UPDATE_NOTIFICATIONS_SUCCESS,
});

export const updateNotificationFailure = (error) => ({
  type: UPDATE_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const deleteNotificationRequest = (id) => ({
  type: DELETE_NOTIFICATIONS_REQUEST,
  payload: id
});

export const deleteNotificationSuccess = (id) => ({
  type: DELETE_NOTIFICATIONS_SUCCESS,
  payload: id,
});

export const deleteNotificationFailure = (error) => ({
  type: DELETE_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const clearNotificationErrors = () => ({
  type: CLEAR_NOTIFICATION_ERRORS,
});

export const clearNotificationSuccess = () => ({
  type: CLEAR_NOTIFICATION_SUCCESS,
});